import { defaultConfig } from '@formkit/vue'
import { en } from '@formkit/i18n'

function prefixErrorMessages(obj) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      typeof value === 'function'
        ? (...args) => `Error: ${value(...args)}` // Wrap function return value
        : `Error: ${value}` // Prefix normal strings
    ])
  )
}

const config = defaultConfig({
  locales: {
    en: {
      ui: {...en.ui},
      validation: prefixErrorMessages(en.validation)
    }
  }, // Set custom messages
  locale: 'en',
})

export default config
